import React from 'react'
import styled from 'styled-components'

type BoardProps = {
  isTransparent?: boolean
  fullHeight?: boolean
  children: React.ReactNode
}
export const Board = (props: BoardProps) => {
  return (
    <Root
      $isTransparent={props.isTransparent ?? false}
      $fullHeight={props.fullHeight ?? true}
    >
      <Main>{props.children}</Main>
    </Root>
  )
}

const Root = styled.div<{ $isTransparent: boolean; $fullHeight: boolean }>`
  border-radius: 12px;
  border: 1px solid var(--background-3);
  background: ${({ $isTransparent }) =>
    $isTransparent ? 'transparent' : 'var(--background-1)'};
  transition: background 0.2s ease;
  overflow: auto;
  height: ${({ $fullHeight }) => ($fullHeight ? '100%' : 'auto')};
  display: grid;
  grid-template-columns: 1fr auto;
`
const Main = styled.div`
  overflow: auto;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
